import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {Certificate2Service} from 'src/app/services/certificate2.service';
import {ContextService} from '../services/context.service';
import {SubscriptionsService} from 'src/app/services/subscriptions.service';
import {EventService} from '../services/event.service';
import {FormGroup} from '@angular/forms';
import {AgendaService} from '../services/agenda.service';
import {EnrollmentService} from '../services/enrollment.service';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {TopicService} from '../services/topic.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {CertificatesSpeakersDialogComponent} from './dialogs/certificates-speakers-dialog/certificates-speakers-dialog.component';

@Component({
  selector: 'app-certificates-speakers',
  templateUrl: './certificates-speakers.component.html',
  styleUrls: [ './certificates-speakers.component.scss' ]
})
export class CertificatesSpeakersComponent implements OnInit {

  public isCongress = false;
  public uid: any;
  public title: any;

  public displayedCertificateStaffColumns: string[] = [ 'icon', 'member_name', 'viewer', 'selected' ];
  public staffDataSource: MatTableDataSource<any>

  public staffs: any[] = [];
  public allSponsors: any[] = [];

  public eventForm: FormGroup;
  public isHistoric: boolean;

  public waiting: any;
  public currentEvent: any;

  public master: any;
  public event: any;

  public events: any[] = [];
  public enrollments: any[] = [];

  constructor (
    public _eventService: EventService,
    public _agendaService: AgendaService,
    private _activeRoute: ActivatedRoute,
    public _certificateService: Certificate2Service,
    private _contextService: ContextService,
    private _enrollmentService: EnrollmentService,
    public _subscriptionsService: SubscriptionsService,
    private _topicService: TopicService,
    private _spinnerService: SpinnerService,
    private _dialog: MatDialog,
  ) { }

  ngOnInit () {
    this._activeRoute.params.subscribe(params => {
      this.isCongress = params[ 'isCongress' ] === 'true';
      this.uid = params[ 'uid' ];
      // console.log("uid: " + this.uid)
      this.selectContext()
    })
  }

  applyFilter (filterValue: string) {
    this.staffDataSource.filter = filterValue.trim().toLowerCase();
  }

  async selectContext () {

    this.waiting = this._spinnerService.show();

    if (this.isCongress) {
      this.master = await this._contextService.getMasterEvent(this.uid);
      this.title = this.master.name; // + " - " + this.master.id;
      this.eventForm = this._certificateService.createForm(this.master)
    } else {
      this.event = await this._contextService.getEvent(this.uid);
      this.title = this.event.name;
      this.eventForm = this._certificateService.createForm(this.event)
    }

    this.events = await this._contextService.getEventsInContext(this.isCongress, this.uid);
    // console.log("events: " + JSON.stringify(this.events));
    //
    const agenda = await this._agendaService.selectByEvents(this.events);
    this.enrollments = await this._enrollmentService.selectByEvents(this.events)

    // console.log("enrollments: " +  JSON.stringify(this.enrollments))
    // console.log("---------------------------------")
    // console.log(JSON.stringify(this.enrollments))

    this.processStaff(agenda, this.enrollments);

  }

  async processStaff (agenda: any[], enrollments: any[]) {

    this.staffs = [];

    agenda.forEach((item: any) => {
      let enroll = enrollments.find((e) => {
       if (item.topic_id) {
          return e.member_id == item.member_id
            && e.event_id == item.event_id
            && e.activity_id == item.activity_id
            && e.topic_id == item.topic_id
       } else {
         return e.member_id == item.member_id
           && e.event_id == item.event_id
           && e.activity_id == item.activity_id
       }
      })

      let selected: boolean = false;
      let certificate_url: string = "";

      if (enroll) {
        selected = true;
        // console.log("certificate_url: " + enroll.certificate_url)
        certificate_url = enroll.certificate_url
      }

      let dt: any = item.day_date
      let dtFull = new Date(dt.seconds * 1000)

      this.staffs.push({
        "enroll_id": enroll ? enroll.id : '',
        "event_id": item.event_id,
        "event_name": item.event_name,
        "day_id": item.day_id,
        "day_name": item.day_name,
        "day_date": dtFull,
        "activity_id": item.activity_id,
        "activity_name": item.activity_name,
        "topic_id": item.topic_id ? item.topic_id : "",
        "topic_name": item.topic_name,
        "member_id": item.member_id,
        "member_name": item.member_name,
        "type": item.role_name,
        "selected": selected,
        "certificate_url": certificate_url
      })

    })

    this.staffs.sort(this.compareMembers)

    // console.log("staffs: " + JSON.stringify(this.staffs))
    //
    this.staffDataSource = new MatTableDataSource(this.staffs)
    this.waiting.close();
  }

  compareMembers (a, b) {

    const pa = String(a.member_name)
    const pb = String(b.member_name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }

  openCertificateConfigDialog () {

    let data = {};

    if (this.isCongress) {
      data = {
        "id": this.master.id,
        "name": this.master.name,
        "isCongress": this.isCongress,
      }
    } else {
      data = {
        "id": this.event.id,
        "name": this.event.name,
        "isCongress": this.isCongress,
      }
    }

    let dialogRef = this._dialog.open(CertificatesSpeakersDialogComponent, {
      width: '920px',
      height: '630px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed()
      .subscribe(async (response) => {
        if (!response) {
          return;
        }

        const actionType: string = response[ 0 ];

        if (actionType == 'ok') {

          const form: any = response[ 1 ];
          const objectImage: string = response[ 2 ];
          const formData = form.getRawValue();

          // console.log("data: " + JSON.stringify(data));
          // console.log("objectImage: " + objectImage);
          console.log("formData: " + JSON.stringify(formData));

          const entity = {
            "id": formData.event_id,
            "name": formData.event_name,
            "isCongress": formData.isCongress,
            "staff_role": formData.staff_role,
            "staff_qrCode": formData.staff_qrCode,
            "staff_image_url": formData.staff_image_url
          }

          console.log("entity: " + JSON.stringify(entity));

          await this._certificateService.updateConfig(entity)
            .then(async () => {

              if (objectImage) {
                await this._certificateService.uploadImage(objectImage, entity.id, "staff_")
                  .then((result) => {
                    console.log("uploadImage result: " + JSON.stringify(result))
                  })
                  .catch((error) => {
                    console.log("uploadImage error: " + JSON.stringify(error.message))
                  })
              }
            
            })
            
        }



      })
  }

  async updateStaffEnrollments () {

    this.waiting = this._spinnerService.show();

    // console.log("updateStaffEnrollments")

    const topics = await this._topicService.selectByEvents(this.events);
    // console.log("topics: " + JSON.stringify(topics));

    let array = this.staffDataSource.data

    for (const item of array) {
      
      // console.log("item.topic_id: " + item.topic_id)

      let existInEnrollments = this.enrollments.find((e: any) => {

        return e.member_id == item.member_id &&
          e.type != "participante" &&
          e.activity_id == item.activity_id &&
          e.topic_id == item.topic_id &&
          e.type == item.type;
      })

      if (item.selected && !existInEnrollments) {

        let texts = topics.find((e) => {
          return e.id == item.topic_id
        })

        let enrollment: any = {
          created: new Date(),
          event_id: item.event_id,
          event_name: item.event_name,
          day_id: item.day_id,
          day_name: item.day_name,
          day_date: item.day_date,
          activity_id: item.activity_id,
          activity_name: item.activity_name,

          topic_id: item.topic_id || "",
          topic_name: item.topic_name || "",

          topic_text1: texts ? texts.text1 || "" : "",
          topic_text2: texts ? texts.text2 || "" : "",
          topic_text3: texts ? texts.text3 || "" : "",

          finished: true,
          member_id: item.member_id,
          member_name: item.member_name,
          certificate_url: "",
          type: item.type
        }

        // console.log("insert - " + item.member_name + " - " + JSON.stringify(enrollment))

        await this._enrollmentService.insert(enrollment)
          .then(() => {
            // this.snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((error) => {
            console.log("erro: " + JSON.stringify(error))
            // this.snackBar.openSnackBar("Erro", '', 'error');
          })


      } else if (!item.selected && existInEnrollments) {

        // console.log("remove - " + JSON.stringify(item))

        await this._enrollmentService.remove(item.enroll_id)
          .then(
            async () => {
              // console.log("removed: " + item.enroll_id)
            }
          )
          .catch(
            (error) => {console.log("delete enroll error")}
          )


      }

    }

    this.waiting.close();

    // console.log("this.selectContext();")

    this.selectContext();

  }

  toggleCheckStaff (flag) {
    this.staffDataSource.data.forEach((item) => {
      item.selected = flag;
    })
  }

}
